import { createEffect, type Effect } from 'effector'
import type {
  ApiCommonResponse,
  GenericApiResponse,
} from '../../../interfaces/generic'
import type {
  OVPCreatorData,
  OVPSignInParams,
  OVPSignUpParams,
  OVPSignUpResponse,
  OVPUserAuthData,
  OVPUserAuthEmail,
  OVPUserAuthParams,
  OVPUserAuthPass,
  OVPUserAuthToken,
  OVPUserQRAuthData,
  OVPUserSignInResponse,
} from './index.h'

export type {
  OVPSignInParams,
  OVPSignUpParams,
  OVPSignUpResponse,
  OVPUserAuthData,
  OVPUserAuthEmail,
  OVPUserAuthParams,
  OVPUserAuthPass,
  OVPUserAuthToken,
  OVPUserSignInResponse,
}

export const signInFx: Effect<
  OVPSignInParams,
  OVPUserSignInResponse,
  GenericApiResponse<Error>
> = createEffect()

export const logOutFx: Effect<
  void,
  void,
  GenericApiResponse<Error>
> = createEffect()
export const activateTokenFx: Effect<
  OVPUserAuthToken,
  void,
  GenericApiResponse<Error>
> = createEffect()

// the rejection carries the API envelope, which is where the sign-up error code
// the client has to branch on lives (OVP-2974)
export const signUpFx: Effect<
  OVPSignUpParams,
  OVPSignUpResponse,
  GenericApiResponse<ApiCommonResponse>
> = createEffect()

// Forgot Password effects
export const resetPasswordFx: Effect<
  OVPUserAuthEmail,
  OVPUserAuthEmail,
  GenericApiResponse<Error>
> = createEffect()
export const confirmResetPasswordFx: Effect<
  OVPUserAuthToken,
  OVPUserAuthEmail,
  GenericApiResponse<Error>
> = createEffect()
export const setPasswordFx: Effect<
  OVPUserAuthPass & OVPUserAuthToken,
  void,
  GenericApiResponse<Error>
> = createEffect()

export const creatorJoinFx: Effect<
  OVPCreatorData,
  OVPUserAuthEmail,
  GenericApiResponse<Error>
> = createEffect()

// QR Code effects
export const getInfoViaQRCodeFx: Effect<
  OVPUserAuthToken,
  OVPUserQRAuthData,
  GenericApiResponse<Error>
> = createEffect()
export const confirmSignInByQRCodeFx: Effect<
  OVPUserAuthToken,
  ApiCommonResponse,
  GenericApiResponse<Error>
> = createEffect()
